import type { ReactNode } from "react";
import { Link } from "@mui/material";

interface NameHelperSuggestionProps {
  original: string;
  suggestion: string;
  setValue: (value: string) => void;
  defaultHelpertext?: ReactNode;
}

export function NameHelperSuggestion({
  original,
  suggestion,
  setValue,
  defaultHelpertext,
}: Readonly<NameHelperSuggestionProps>): ReactNode {
  return (
    <span>
      {defaultHelpertext}
      <br />
      {suggestion !== "" && suggestion !== original && (
        <>
          Suggestion :{" "}
          <Link
            variant="caption"
            onClick={() => {
              setValue(suggestion);
            }}>
            {suggestion}
          </Link>
        </>
      )}
    </span>
  );
}
